// Testimonials.jsx
import React from "react";
import Slider from "react-slick";

const testimonials = [
  {
    name: "Rohit S.",
    image: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg",
    rating: 5,
    text: "Fintoo made the process so simple. I compared multiple plans and chose what fit me best in just 10 minutes.",
    gradient: "tw-from-blue-50 tw-to-white",
    border: "tw-border-blue-100",
  },
  {
    name: "Pooja M.",
    image: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg",
    rating: 4,
    text: "I always felt overwhelmed with insurance jargon. With Fintoo, I finally understood what I was buying.",
    gradient: "tw-from-orange-50 tw-to-white",
    border: "tw-border-orange-100",
  },
  {
    name: "Amit K.",
    image: "https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg",
    rating: 5,
    text: "Saved me hours of research. The comparison was clear and helped me get the best plan for my family.",
    gradient: "tw-from-blue-50 tw-to-white",
    border: "tw-border-blue-100",
  },
];

export default function Testimonials() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640, // mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section id="testimonials" className="lg:tw-py-20 tw-py-10 tw-bg-white">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6">
        <div className="tw-text-center lg:tw-mb-16 tw-mb-8">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            Real Stories. Real Trust.
          </h2>
        </div>

        <Slider {...settings} >
          {testimonials.map((t, index) => (
           <div key={index} className="tw-px-2"> 
      <div
        className={`tw-bg-gradient-to-br ${t.gradient} tw-rounded-2xl tw-p-8 tw-border tw-border-solid ${t.border}`}
      >
              <div className="tw-flex tw-items-center tw-mb-6">
                {/* <img
                  src={t.image}
                  alt={t.name}
                  className="tw-w-12 tw-h-12 tw-rounded-full tw-mr-4"
                /> */}
                <div>
                  <h4 className="tw-font-bold tw-text-fintoo-blue">{t.name}</h4>
                  <div className="tw-flex tw-text-yellow-400">
                    {[...Array(t.rating)].map((_, i) => (
                      <i key={i} className="fa-solid fa-star"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="tw-text-gray-700 tw-italic">{t.text}</p>
              </div>
              </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}
